<!-- src/components/ui/DashboardCard.vue -->
<template>
    <component
      :is="to ? 'router-link' : 'div'"
      :to="to"
      class="block transition hover:shadow-lg"
    >
      <div
        class="p-4 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-lg shadow-md flex items-center justify-between"
      >
        <div>
          <h5 class="text-sm font-medium text-gray-500 dark:text-gray-400">
            {{ label }}
          </h5>
          <p class="text-2xl font-bold text-gray-900 dark:text-white">
            {{ value }}
          </p>
          <p v-if="suffix" class="text-xs text-gray-400 mt-1">{{ suffix }}</p>
        </div>
        <div :class="['p-3 rounded-full text-white', iconBg]">
          <slot name="icon" />
        </div>
      </div>
    </component>
  </template>
  
  <script>
  export default {
    name: 'DashboardCard',
    props: {
      label: String,
      value: [Number, String],
      iconBg: {
        type: String,
        default: 'bg-blue-500'
      },
      suffix: {
        type: String,
        default: ''
      },
      to: {
        type: String,
        default: null
      }
    }
  };
  </script>
  